import { BackendUser } from 'model/BackendUser';

export const USER_LIST_PAGE_SIZE = 10;

export type UserListByInitial = {
  [key: string]: BackendUser[];
};
